
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-service/join-eclub",
      function () {
        return require("private-next-pages/customer-service/join-eclub/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-service/join-eclub"])
      });
    }
  